import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import './Auth.css';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await login(formData);
      toast.success('Login successful!');

      // Redirect based on role
      const role = response.data.user.role;
      switch (role) {
        case 'super_admin':
        case 'admin':
        case 'subadmin':
          navigate('/admin/dashboard');
          break;
        case 'employer':
          navigate('/employer/dashboard');
          break;
        case 'candidate':
          navigate('/candidate/dashboard');
          break;
        case 'consultant':
          navigate('/consultant/dashboard');
          break;
        default:
          navigate('/');
      }
    } catch (error) {
      console.error('Login error:', error);
      const errorMessage = error?.error?.message || error?.message || 'Login failed';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {/* Left – Branding */}
      <div className="auth-left">
        <div className="auth-brand">
          <div className="auth-brand-icon">
            <span className="material-symbols-outlined">work</span>
          </div>
          <span className="auth-brand-name">HiringOpen</span>
        </div>
        <h1 className="auth-left-headline">Welcome<br />Back!</h1>
        <p className="auth-left-sub">Sign in to continue your journey to finding the perfect opportunity.</p>
        <div className="auth-features">
          {[
            { icon: 'bookmark', title: 'Saved Jobs', desc: 'Keep track of opportunities that interest you' },
            { icon: 'analytics', title: 'Track Applications', desc: 'Monitor your job search progress in real-time' },
            { icon: 'notifications', title: 'Instant Alerts', desc: 'Stay updated with new job matches' },
            { icon: 'rocket_launch', title: 'Quick Apply', desc: 'Submit applications with just one click' },
          ].map(f => (
            <div key={f.title} className="auth-feature">
              <div className="auth-feature-icon">
                <span className="material-symbols-outlined">{f.icon}</span>
              </div>
              <div className="auth-feature-text">
                <h4>{f.title}</h4>
                <p>{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Right – Form */}
      <div className="auth-right">
        <Link to="/" className="auth-back-link">
          <span className="material-symbols-outlined">arrow_back</span>
          Back to Home
        </Link>
        <div className="auth-form-wrap">
          <div className="auth-form-icon">
            <span className="material-symbols-outlined">login</span>
          </div>
          <h1 className="auth-form-title">Sign In</h1>
          <p className="auth-form-subtitle">Enter your credentials to access your account</p>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="auth-field">
              <label className="auth-label">
                <span className="material-symbols-outlined">email</span>
                Email Address
              </label>
              <input
                type="email"
                name="email"
                className="auth-input"
                placeholder="john@example.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="auth-field">
              <label className="auth-label">
                <span className="material-symbols-outlined">lock</span>
                Password
              </label>
              <div className="auth-password-wrap">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  className="auth-input"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  className="auth-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <span className="material-symbols-outlined">
                    {showPassword ? 'visibility_off' : 'visibility'}
                  </span>
                </button>
              </div>
            </div>

            <div className="auth-footer-row">
              <label className="auth-remember">
                <input type="checkbox" />
                Remember me
              </label>
              <Link to="/forgot-password" className="auth-forgot-link">Forgot Password?</Link>
            </div>

            <button type="submit" className="auth-submit-btn" disabled={loading}>
              {loading ? (
                <><div className="auth-spinner"></div>Signing in…</>
              ) : (
                <>Sign In<span className="material-symbols-outlined">arrow_forward</span></>
              )}
            </button>
          </form>

          <div className="auth-bottom-link">
            Don't have an account? <Link to="/register">Create Account</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
